import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { BaseGesture } from "./gesture";
export var LongPressGesture = /*#__PURE__*/ function(BaseGesture) {
    "use strict";
    _inherits(LongPressGesture, BaseGesture);
    var _super = _create_super(LongPressGesture);
    function LongPressGesture() {
        _class_call_check(this, LongPressGesture);
        var _this;
        _this = _super.call(this);
        _define_property(_assert_this_initialized(_this), "config", {});
        _this.handlerName = "LongPressGestureHandler";
        _this.shouldCancelWhenOutside(true);
        return _this;
    }
    _create_class(LongPressGesture, [
        {
            key: "minDuration",
            value: function minDuration(duration) {
                this.config.minDurationMs = duration;
                return this;
            }
        },
        {
            key: "maxDistance",
            value: function maxDistance(distance) {
                this.config.maxDist = distance;
                return this;
            }
        }
    ]);
    return LongPressGesture;
}(BaseGesture);
